module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9fgMh"))).then(() => parcelRequire('1iHdE'));